import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableCell,
} from "@mui/material";
import { Visibility, DeleteOutline } from "@mui/icons-material";
import {
  StyledBox,
  StyledHeaderCell,
  StyledTableCell,
  StyledTableHead,
  StyledTableRow,
} from "./styles";

export interface Column<T = any> {
  header: string;
  field?: keyof T;
  align?: "left" | "center" | "right";
  width?: number;
  render?: (row: T) => React.ReactNode;
}

interface DataTableProps<T = any> {
  columns: Column<T>[];
  rows: T[];
  minWidthTable?: number;
  onView?: (row: T) => void;
  onDelete?: (row: T) => void;
}

function DataTable<T>({
  columns,
  rows,
  minWidthTable,
  onView,
  onDelete,
}: DataTableProps<T>) {
  return (
    <StyledBox>
      <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
        <Table sx={{ minWidth: minWidthTable }} size="small">
          <StyledTableHead>
            <StyledTableRow>
              {columns.map((col, index) => (
                <StyledHeaderCell
                  key={index}
                  align={col.align || "left"}
                  sx={{ width: col.width }}
                >
                  {col.header}
                </StyledHeaderCell>
              ))}

              {(onView || onDelete) && <StyledHeaderCell />}
            </StyledTableRow>
          </StyledTableHead>

          <TableBody>
            {rows.map((row, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <StyledTableCell
                    key={colIndex}
                    align={col.align || "left"}
                    sx={{
                      maxWidth: 190,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {col.render
                      ? col.render(row)
                      : col.field
                        ? (row[col.field] as React.ReactNode)
                        : null}
                  </StyledTableCell>
                ))}

                {(onView || onDelete) && (
                  <TableCell
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {onView && (
                      <IconButton
                        color="primary"
                        onClick={() => onView(row)}
                      >
                        <Visibility />
                      </IconButton>
                    )}

                    {onDelete && (
                      <IconButton
                        color="error"
                        onClick={() => onDelete(row)}
                      >
                        <DeleteOutline />
                      </IconButton>
                    )}
                  </TableCell>
                )}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </StyledBox>
  );
}

export default DataTable;
